export default "__VITE_ASSET__0sR0cG4b__"